import { Component, OnInit } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from '../../service/auth/auth.service';
import { ConfigService } from '../../service/config/config.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { ChangesPage } from './changes/changes.page';

@Component({
  selector: 'app-stamdata',
  templateUrl: './stamdata.page.html',
  styleUrls: ['./stamdata.page.scss'],
  providers: [DecimalPipe]
})
export class StamdataPage implements OnInit {

  private stamdata;

  private lastUpdated: string;

  private farmernumber: string;
  private farmerDisplayName: string;
  private street: string;
  private zipcode_city: string;
  private email: string;

  private grundtegning: string;
  private levformeget: string;
  private lejet: string;
  private udlejet: string;
  private samletleveringsret: string;

  constructor(private auth: AuthService, private http: HttpClient, private config: ConfigService, private decimalPipe: DecimalPipe, private datePipe: DatePipe, private modalCtrl: ModalController) { }

  ngOnInit() {
    this.getStamdata();
  }

  formatNumber(num: number): string {
    return this.decimalPipe.transform(num, '1.0-0').replace(',', '.');
  }
  getFormattedDate(dateStr: string): string {
    let date = this.datePipe.transform(dateStr, 'dd-MM-yy');
    let time = this.datePipe.transform(dateStr, 'HH.mm');
    return `Senest opdateret: ${date} Kl. ${time}`;
  }

  public async getStamdata(): Promise<any>{
    if(this.auth.userProfile){
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };

      const url = `${this.config.basePath}/api/farmers/${this.auth.userProfile.id}?filter=${encodeURIComponent(JSON.stringify({ include: 'masterdata' }))}`;
      this.http.get<any[]>(url, options)
        .subscribe((data)=>{
          this.stamdata = data
          this.farmernumber = data['farmernumberakd'];

          this.lastUpdated = data['masterdata'][0]['timestamp'];
          this.farmerDisplayName = data['displayname'];
          this.street = data['address'].street;
          this.zipcode_city = data['address'].zipcode + ' ' + data['address'].city;
          this.email = data['email'];

          this.grundtegning = this.formatNumber(data['masterdata'][0].basic_amount);
          this.levformeget =  this.formatNumber(data['masterdata'][0].amount_too_much);
          this.lejet =  this.formatNumber(data['masterdata'][0].amount_rented);
          this.udlejet =  this.formatNumber(data['masterdata'][0].amount_rented_out);
          this.samletleveringsret =  this.formatNumber(data['masterdata'][0].total_amount);
        });

    }
  }

  async suggestChanges(){
    //this.router.navigate([`/stamdata/changes`], );
    let modal = await this.modalCtrl.create({
      component: ChangesPage,
      componentProps: {
        modalCtrl: this.modalCtrl,
        stamdata: this.stamdata
      },
      backdropDismiss: true,
    });
    await modal.present();
    console.log('MODAL');
  }

}

